import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import styles from './dropdown-list.scss';

class DropdownList extends React.Component {
  constructor() {
    super();

    this.setListRef = this.setListRef.bind(this);
  }

  componentDidUpdate(prevProps) {
    const newItems = _.flatten(this.props.children) > _.flatten(prevProps.children);
    if (this.props.allowTopScroll && this._list && newItems) {
      this._list.scrollTop = 0;
    }
  }

  setListRef(el) {
    this._list = el;
  }

  render() {
    if (this.props.open === true) {
      return (
        <div
          ref={this.setListRef}
          className={classnames(
            'dropdown-drop',
            'dropdown-results',
            'open',
            this.props.open ? styles.open : '',
            this.props.wide ? styles.wide : '',
            this.props.openRight ? styles.openRight : ''
          )}
          onMouseDown={this.props.onMouseDown}
        >
          {this.props.children}
        </div>
      );
    }

    return null;
  }
}

DropdownList.propTypes = {
  onMouseDown: React.PropTypes.func,
  open: React.PropTypes.bool,
  children: React.PropTypes.any,
  allowTopScroll: React.PropTypes.bool,
  wide: React.PropTypes.bool,
  openRight: React.PropTypes.bool
};

export default DropdownList;



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown-list.jsx